<!--
  鉴定能力
-->
<template>
  <div class="capacity">
    <div class="capacity-tabs">
      <div @click="chageTab(1)" :class="{ 'tab-active': tabSelected == 1}">国家支持的农业机械推广鉴定能力</div>
      <div class="vertical-line"></div>
      <div @click="chageTab(2)" :class="{ 'tab-active': tabSelected == 2}">省级农业机械推广鉴定能力</div>
      <div class="vertical-line"></div>
      <div @click="chageTab(3)" :class="{ 'tab-active': tabSelected == 3}">专项鉴定能力</div>
    </div>

    <div class="capacity-content">
      <div class="content-left">
        <div class="content-left-child">
          <div class="content-left-child-inner">
            <div class="inner-top">
              <div class="inner-top-left" :data-content="this.needObj.count">{{this.needObj.count}}</div>
              <span class="inner-top-right">项</span>
            </div>
            <div class="inner-bottom">{{this.needObj.name}}</div>
          </div>
        </div>
      </div>
      <div class="content-right" id="contentRight"></div>
    </div>

    <!-- 详情 -->
    <div id="detailPopup" class="popup">
      <p>{{hoverObj.dgName}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'leftFirst',
  props: {
    listObj: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      tabSelected: 1,
      container: null,
      children: [],
      isPaused: false,
      animationId: null,
      // 最大div宽度
      maxDivWidth: 30,
      backgroundArr: [
        {
          background: `rgba(0, 59, 91, 1)`,
          hoverBackground: 'linear-gradient(0deg, #006399 0%, #0089D3 100%)',
          borderColor: '#8097A3',
          hoverBorderColor: '#8097A3',
          color: '#BAE7FF',
          hoverColor: '#FFFFFF',
        },
        {
          background: `rgba(0, 74, 24, 1)`,
          hoverBackground: 'linear-gradient(0deg, #006E27 0%, #00C746 100%)',
          borderColor: '#046623',
          hoverBorderColor: '#046623',
          color: '#BAFFE3',
          hoverColor: ' #FFFFFF',
        },
        {
          background: `rgba(71, 71, 0, 1)`,
          hoverBackground: 'linear-gradient(0deg, #666600 0%, #B5B500 100%)',
          borderColor: '#6F8127',
          hoverBorderColor: '#6F8127',
          color: '#FFFFBA',
          hoverColor: ' #FFFFFF',
        },
        {
          background: `rgba(74, 49, 0, 1)`,
          hoverBackground: 'linear-gradient(0deg, #664400 0%, #B57900 100%)',
          borderColor: '#58581A',
          hoverBorderColor: '#58581A',
          color: '#FFE8BA',
          hoverColor: ' #FFFFFF',
        }
      ],
      needObj: {
        name: '',
        count:  0,
        typeList: [],
      },
      hoverObj: {
        dgName: '',
        url: '',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initBox(); 
    });
  },
  watch: {
    'tabSelected': {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.initBox(); 
        });
      }
    },
    'listObj': {
      deep: true,
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          this.initBox(); 
        });
      }
    }
  },
  methods: {
    chageTab(index) {
      this.tabSelected = index;
    },
    getNeedListObj() {
      if(this.listObj.length == 0) {
        return ;
      }
      for(let i = 0; i < this.listObj.length;i++) {
        if(this.tabSelected == 1) {
          if(this.listObj[i]?.capacityName == '国家支持的农业机械推广鉴定能力') {
            this.needObj = {
              name: '国家支持的农业机械推广鉴定能力',
              count: this.listObj[i]?.count || 0,
              typeList: this.listObj[i]?.typeList || [],
            }
          }
        }
        if(this.tabSelected == 2) {
          if(this.listObj[i]?.capacityName == '省级农业机械推广鉴定能力') {
            this.needObj = {
              name: '省级农业机械推广鉴定能力',
              count: this.listObj[i]?.count || 0,
              typeList: this.listObj[i]?.typeList || [],
            }
          }
        }
        if(this.tabSelected == 3) {
          if(this.listObj[i]?.capacityName == '专项鉴定能力') {
            this.needObj = {
              name: '专项鉴定能力',
              count: this.listObj[i]?.count || 0,
              typeList: this.listObj[i]?.typeList || [],
            }
          }
        }
      }
    },
    initBox() { 
      this.getNeedListObj();
      this.container = document.getElementById('contentRight');
      cancelAnimationFrame(this.animationId);
      this.container.innerHTML = '';
      this.children = [];
      for(let i = 0; i < this.needObj.typeList.length; i++) {
        this.createChild(this.needObj.typeList[i], i);
      }
      this.updatePositions();
      this.enterAndLeave();
    },
    createChild(info, index) {
      let that = this;
      const div = document.createElement('div');
      const popup = document.getElementById('detailPopup');
      div.className = 'child-class';
      
      // 初始随机位置
      div.x = Math.random() * (this.container.offsetWidth - 100) * 0.5;
      div.y = Math.random() * (this.container.offsetHeight - 50);
      
      // 随机速度（-2到2px/帧）
      div.dx = (Math.random() - 0.5);
      div.dy = (Math.random() - 0.5);
      
      // 随机颜色
      div.textContent = info.productName;
      div.hoverObj = info;
      let tmepIndex = (index + 1) % this.backgroundArr.length;
      div.styleObj = this.backgroundArr[tmepIndex];
      div.style.background =  this.backgroundArr[tmepIndex].background;
      div.style.border = `1px solid ${this.backgroundArr[tmepIndex].borderColor}`;
      div.style.color = this.backgroundArr[tmepIndex].color;
      div.style.zIndex = 1;

      div.addEventListener('click', function(e) {
        const urlInfo = new URL(that.hoverObj.url);
        const locProtocol = window.location.protocol;
        let file = null;
        if(locProtocol.indexOf('https') >= 0) {
          file = `/tohttp${urlInfo.pathname}${urlInfo.search}`
        }else {
          file = that.hoverObj.url;
        }
        window.open(file)
        // window.open(that.hoverObj.url)
      })

      // 添加hover事件
      div.addEventListener('mouseover', function(e) {
        let target = e.target;
        div.style.background = target.styleObj.hoverBackground;
        div.style.border = `1px solid ${target.styleObj.hoverBorderColor}`;
        div.style.color = target.styleObj.hoverColor;
        div.style.zIndex = 2;
        popup.style.display = 'block';
        that.hoverObj = target.hoverObj;
         // 计算定位
        const rect = this.getBoundingClientRect();
        popup.style.top = `${rect.top - rect.height * 2.5}px`;
        popup.style.left = `${rect.right + 10}px`; // 右侧10px
      });

      div.addEventListener('mouseout', function(e) {
        let target = e.target;
        div.style.background = target.styleObj.background;
        div.style.border = `1px solid ${target.styleObj.border}`;
        div.style.color = target.styleObj.color;
        div.style.zIndex = 1;
        popup.style.display = 'none';
      });
      
      this.container.appendChild(div);
      this.children.push(div);
      if(div.offsetWidth >= this.maxDivWidth) {
        this.maxDivWidth = div.offsetWidth;
      }
      // return div;
    },
    // 启动动画
    updatePositions() {
      this.children.forEach(child => {
        if(this.isPaused) return;
        // 边界检测
        if(child.x <=0 || child.x >= this.container.offsetWidth - this.maxDivWidth) child.dx *= -1;
        if(child.y <=0 || child.y >= this.container.offsetHeight-50) child.dy *= -1;
        
        // 更新坐标
        child.x += child.dx;
        child.y += child.dy;
        
        // 应用位置
        child.style.transform = `translate(${child.x}px, ${child.y}px)`;
      });
      
      this.animationId = requestAnimationFrame(this.updatePositions);
    },
    // mouseenter、mouseleave
    enterAndLeave() {
      this.children.forEach(child => {
        child.addEventListener('mouseenter', () => {
          this.isPaused = true;
          cancelAnimationFrame(this.animationId);
        });

        child.addEventListener('mouseleave', () => {
          this.isPaused = false;
          this.updatePositions(); // 恢复动画
        });
      });
    }
  }
}
</script>
<style lang="scss">
.vehicle-identify {
  .child-class {
    display: inline-block;
    position: absolute;
    padding: 6px 17px;
    border-radius: 4px;
    cursor: pointer;
    transition: transform 0.3s;
  }
}
</style>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.capacity {
  font-family: 'Microsoft YaHei';
  font-size: fontSize(14);
  margin-top: vh(9);
  .capacity-tabs {
    display: flex;
    border-top: 1px solid transparent;
    border-image: linear-gradient(to right, rgba(40, 166, 84, 1), rgba(40, 166, 84, 0.1)) 1;
    cursor: pointer; 
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: vw(217);
      height: vh(44);
      color: #5FFF97;
      background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/bg_titlemenu_nl.png");
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .vertical-line {
      width: vw(1);
      height: vh(44);
      background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/bg_titlemenu_nl_line.png");
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .tab-active {
      background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/bg_titlemenu_nl_c.png");
      border-top: 1px solid #C78500;
      color: #FFC95E;
      margin-top: -1px;
    }
  }

  .capacity-content {
    display: flex;
    position: relative;
    height: vh(162);
    .content-left {
      position: relative;
      width: vw(220);
      .content-left-child {
        position: absolute;
        bottom: 0;
        left: vw(4);
        width: vw(215);
        height: vh(136);
        background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/capacity-bg.png");
        background-repeat: no-repeat;
        background-size: 100%; 
        font-size: fontSize(14);
        color: #5FFF97;
        .content-left-child-inner {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: vh(22);
          .inner-top {
            display: flex;
            align-items: baseline;
            .inner-top-left {
              position: relative;
              margin-left: vw(10);
              padding-right: vw(6);
              font-family: 'Rajdhani-Bold';
              font-size: fontSize(48);
              font-style: italic;
              background: linear-gradient(0deg, #8FF7B4 28%, rgba(255,255,255,1) 70%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              margin-right: vw(5);
            }
            .inner-top-right {
              color: #5FFF97;
              font-size: fontSize(16);
            }
            .inner-top-left::before {
              content: attr(data-content);
              position: absolute;
              top: 0;
              left: 0;
              color: transparent;
              text-shadow: 0px 3px 7px rgba(0,0,0,0.1);
            }
          }
          .inner-bottom {
            width: vw(126);
            height: vh(33);
            text-align: center;
          }
        }
      }
    }
    .content-right {
      width: vw(434);
      position: relative;
      // overflow: hidden;

    }
    }


    .popup {
      display: none; /* 初始隐藏 */
      position: absolute;
      max-width: vw(204);
      padding: vh(10) vw(10);
      font-size: fontSize(14);
      color: #DEFFE9;
      background: linear-gradient(0deg, rgba(3,49,19,0.87), rgba(5,51,21,0.7));
      border: 1px solid #5FD488;
      z-index: 1000;
      p {
        max-width: vw(204);
        white-space: nowrap; /* 防止换行 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 显示省略号 */
      }
    }
    .popup::before {
      content: "";
      position: absolute;
      left: -10px; /* 调整三角形的位置，使其紧挨着div的左侧 */
      top: 50%; /* 垂直居中 */
      transform: translateY(-50%); /* 垂直居中 */
      width: 0;
      height: 0;
      border-top: 8px solid transparent; /* 上边框透明 */
      border-bottom: 8px solid transparent; /* 下边框透明 */
      border-right: 10px solid #5FD488; /* 右边框为背景色，形成三角形 */
    }
  }

 



</style>
